import { useContext } from "react";

import BoltClientContext from "../context/BoltClientContext";

const useBoltClient = () => useContext(BoltClientContext);

export default useBoltClient;
